module.exports = __webpack_public_path__ + "media/images/payments/payone-8355dd6a3ddf89adc9830f992b9bd28d.svg";